import { render, staticRenderFns } from "./TemplatesList.vue?vue&type=template&id=47c061a1&scoped=true&"
import script from "./TemplatesList.vue?vue&type=script&lang=ts&"
export * from "./TemplatesList.vue?vue&type=script&lang=ts&"
import style0 from "./TemplatesList.vue?vue&type=style&index=0&id=47c061a1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c061a1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
